import { render, staticRenderFns } from "./control-right.vue?vue&type=template&id=60f3f37f&scoped=true&"
import script from "./control-right.vue?vue&type=script&lang=js&"
export * from "./control-right.vue?vue&type=script&lang=js&"
import style0 from "./control-right.vue?vue&type=style&index=0&id=60f3f37f&prod&lang=scss&scoped=true&"
import style1 from "./control-right.vue?vue&type=style&index=1&id=60f3f37f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f3f37f",
  null
  
)

export default component.exports